module.exports = __webpack_public_path__ + "assets/5159829c8f8cd49852a4b1286f47d295.png";